export class PlanActuacion {
    idPlan: string;
    fecha: string;
    texto: string;
    tipo: string;
    hora: string;
    visita: string;
    numeroExpediente: string;
    dniMedico: string;
    dniBorrado: string;
    motivoBorrado: string;
    cias: string;
}



// WEBPACK FOOTER //
// ./src/models/planactuacion.ts